import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
  enableFormReconciliationMode,
  clearFormMessage,
  updateMultipageFormValues,
} from 'Store/forms/actions';
import {
  removePrefixFromFields,
  fieldsWithValuesOnly,
  generateInitialValuesFromMultipageForm,
} from 'Store/forms/helpers';

import { getActiveUser, getMultipageFormValues } from 'Store/reducers';

import ContentFrame from 'Components/ContentFrame';
import PaymentFlowHeader from 'Components/PaymentFlowHeader/PaymentFlowHeader';
import Form from 'Components/Form';
import Loading from 'Components/Loading';

import { ROUTES } from 'Settings/route-strings';

class CreateAccount extends React.Component {
  state = {};

  componentDidMount() {
    this.setInitialFieldValues();
  }

  componentDidUpdate() {
    // Check to see if we have an active user and send them on their way.
    if (this.props.activeUser) {
      this.props.history.push(ROUTES.INDEX);
    }

    this.setInitialFieldValues();
  }

  handleSubmit = (fields, isFormValid) => {
    this.props.clearFormMessage('createAccount', 'createAccount');
    if (isFormValid) {
      this.setState({ isPosting: true });
      const fieldsWithoutPrefix = removePrefixFromFields(
        fields,
        'createAccount'
      );
      const fieldValues = fieldsWithValuesOnly(fieldsWithoutPrefix);
      this.props.updateMultipageFormValues('loggedOutPayment', fieldValues);
      console.log('Yes, created!');
      this.props.history.push(ROUTES.SUBSCRIPTION_PAYMENT);
    }

    this.props.enableFormReconciliationMode('createAccount', 'createAccount');
  };

  setInitialFieldValues = () => {
    if (this.props.multipageFormValues && !this.state.initialFieldSettings) {
      this.setState({
        initialFieldSettings: generateInitialValuesFromMultipageForm(
          this.props.multipageFormValues
        ),
      });
    }
  };

  render() {
    // When this value is null, it hasn’t been read yet.
    if (!this.state.initialFieldSettings) return <Loading />;

    return (
      <main className="Page__content">
        <ContentFrame
          pageType="transactional"
          size="medium"
          externalHeader={
            <PaymentFlowHeader containerSize="medium" activeZeroIndex={1} />
          }
        >
          <Form
            type="createAccount"
            id="createAccount"
            formStyle="acceptTeacherInvitation"
            initialFieldSettings={this.state.initialFieldSettings}
            messagePosition="fixed-top"
            submitButtonType="primary"
            submitHandler={this.handleSubmit}
          />
        </ContentFrame>
      </main>
    );
  }
}

const mapStateToProps = state => {
  return {
    activeUser: getActiveUser(state),
    multipageFormValues: getMultipageFormValues(state, 'loggedOutPayment'),
  };
};

export default withRouter(
  connect(mapStateToProps, {
    enableFormReconciliationMode,
    clearFormMessage,
    updateMultipageFormValues,
  })(CreateAccount)
);
